angular.module('common.directives').directive('notificationItem', function () {
  return {
    templateUrl: './templates/notification-item.view.html?t=' + webpackHash,
    controller: 'notificationItemCtrl',
    link: function (scope, element, attrs) {
      // Additional logic if needed
    }
  }
})
